import Section from '../components/Section'
import React from 'react'
import EarningsCalculator from './EarningsCalculator/EarningsCalculator'
import Container from '@material-ui/core/Container'
import withStyles from '@material-ui/core/styles/withStyles'
import Grid from '@material-ui/core/Grid'
import ProductsImage from '../../resources/assets/images/earningscalculator/products-image.svg'
import Link from '@material-ui/core'

const styles = ({palette}) => ({
  subHeader: {
    color: palette.text.primary,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.5',
    letterSpacing: '0.51px',
    paddingLeft: '20px',
    marginTop: '14px',
    maxWidth: '900px',
  },
  productImage: {
    display: 'flex',
    alignSelf: 'center',
    width: '240px',
  },
})


const EarningsSection = ({classes, ...props}) => (
  <Section
    headingTitle="Ganhos como Consultora"
    headingSubtitle="Você pode escolher vender Natura, Avon ou ambas a marcas e todas as suas vendas contam para o Plano de Crescimento.
    Quanto maior o seu nível, maiores os ganhos! Confira o plano completo"
    subHeaderStyle={classes.subHeader}
    {...props}>
    <Container component="article">
      <Grid direction="column" alignItems="center" container>
        <EarningsCalculator
          productsImage={
            <img
              className={classes.productImage}
              alt="Produtos da Natura: Ekos Castanha (marcado com o número 1), Tododia Flor de Lis (marcado com o número 2), Essencial Supreme (marcado com o número 3) e Lumina Máscara (marcado com o número 4)"
              data-gtm-category="landing_ganhos_como_consultora"
              data-gtm-main-action="ab_test"
              aria-hidden={true}
              src={ProductsImage}
            />
          }
        />
      </Grid>
    </Container>
  </Section>
)

export default withStyles(styles)(EarningsSection)
